<template>
  <div>
    <div
      style="
        border-bottom: 1px solid rgba(155, 155, 155, 0.25);
        margin-bottom: 20px;
      "
    >
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="申请企业" style="margin-right: 30px">
          <el-input v-model="formInline.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            :editable="false"
            :clearable="false"
            v-model="formInline.date_range"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
            class="bg5584FF formBotton"
            >查询</el-button
          >
          <el-button type="info" @click="reset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- <el-link style="margin-bottom: 20px;" type="primary" @click="exportData">{{exportLabel}}</el-link> -->
    <el-table
      border
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
      v-loading="loading"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" fixed></el-table-column>
      <el-table-column
        prop="name"
        label="申请企业"
        align="center"
        fixed
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span class="detail" @click="handleDetail1(scope.row)">{{
            scope.row.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="applyName"
        label="申请人"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="申请时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="applyPhone"
        label="联系电话"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="reason"
        label="申请原因"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="updateStatus"
        label="状态"
        align="center"
      ></el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class="dialog770 titleChange"
      >
        <template slot-scope="scope">
          <el-button
            :disabled="scope.row.btndisable"
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="handleDetail2(scope.row)"
            >修改</el-button
          >
          <el-button
            :disabled="scope.row.btndisable"
            type="primary"
            size="mini"
            class="bg5584FF phone_btn_margin"
            @click="handleDetail3(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="pageBox">
      <el-pagination
        class="pagePC"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="10"
        layout="total,  prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <van-pagination
        class="pagePhone"
        v-model="currentPage"
        :total-items="total"
        :items-per-page="10"
        :show-page-size="3"
        @change="changePage"
        force-ellipses
      />
    </div> -->
    <el-dialog
      append-to-body
      title="审核意见"
      :visible.sync="passDialogVisible"
      :close-on-click-modal="false"
      class="titleChange"
      width="770px"
    >
      <el-form
        :model="passForm"
        :rules="rules"
        ref="passForm"
        label-width="135px"
        class="demo-RuleForm"
        size="small"
        v-loading="passLoading"
      >
        <el-form-item label="审核意见：" prop="reason">
          <el-input v-model="passForm.reason"></el-input>
        </el-form-item>
      </el-form>
      <div class="btnBox">
        <el-button type="primary" @click="surePass()">确定</el-button>
        <el-button @click="passDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 查看详情 -->
    <el-dialog
      title="企业详情"
      :visible.sync="showDetailWindow"
      class="titleChange bodyScroll"
      :width="screenWidth < 1200 ? '94%' : '60%'"
      :close-on-click-modal="false"
    >
      <div class="lineTitle">
        <span>基本信息</span>
      </div>
      <el-form
        :inline="true"
        :model="editObj"
        class="demo-form-inline half"
        size="mini"
        label-width="135px"
        label-position="right"
        ref="editForm"
      >
        <el-row>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业名称" prop="name">
              <el-input v-model.trim="editObj.name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="统一社会信用代码">
              <el-input v-model.trim="editObj.code" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="登记注册类型">
              <el-input v-model.trim="editObj.registerType" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="国民经济行业">
              <el-input v-model.trim="editObj.industryType" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册资金（万元）">
              <el-input
                v-model.trim="editObj.registerMoney"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册时间">
              <el-input v-model="editObj.registerTime" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="法定代表人">
              <el-input
                v-model.trim="editObj.representativePerson"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="邮政编码">
              <el-input v-model.trim="editObj.postCode" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="所在工业园区">
              <el-input v-model.trim="editObj.park" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否规上">
              <el-input v-model.trim="editObj.aboveScale" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否上市">
              <el-input v-model.trim="editObj.listed" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否军工">
              <el-input v-model.trim="editObj.military" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业规模">
              <el-input v-model.trim="editObj.companySize" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业类别">
              <el-input
                v-model.trim="editObj.companyCategory"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业性质">
              <el-input
                v-model.trim="editObj.companyNature"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="“565”产业">
              <el-cascader
                v-model="editObj.company565"
                :options="Company565List"
                :props="deftProps"
                disabled
                placeholder
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否10亿元">
              <el-input v-model.trim="editObj.oneBillion" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="提质倍增">
              <el-input
                v-model.trim="editObj.multiplication"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否店小二服务">
              <el-input
                v-model.trim="editObj.xiaoerService"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="“三大改造”实施">
              <el-select v-model="editObj.threeChanges" multiple disabled>
                <el-option label="智能化改造" value="智能化改造"></el-option>
                <el-option label="绿色化改造" value="绿色化改造"></el-option>
                <el-option label="技术改造" value="技术改造"></el-option>
                <el-option label="未实施" value="未实施"></el-option>
                <el-option label="已实施" value="已实施"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册区县" class="selection_item">
              <el-input
                class="city_input_box_1"
                v-model.trim="luoyangCity"
                disabled
                :placeholder="city_name"
              ></el-input>
              <el-input
                class="city_input_box_1"
                v-model.trim="editObj.district"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册地址">
              <el-input
                v-model.trim="editObj.registerAddress"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="24">
            <el-form-item label="办公地址">
              <el-input
                class="address_input_box"
                v-model.trim="editObj.officeAddress"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="24">
            <el-form-item label="公司简介">
              <el-input
                class="address_input_box"
                type="textarea"
                v-model="editObj.companyProfile"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <hr style="width: 100%; margin: 30px 0" />
        <div class="lineTitle" style="width: 100%">联系信息</div>
        <el-row>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系邮箱">
              <el-input v-model.trim="editObj.companyEmail" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="法定代表人电话">
              <el-input
                v-model.trim="editObj.representativePhone"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系人姓名">
              <el-input v-model.trim="editObj.contactName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系人职务">
              <el-input
                v-model.trim="editObj.contactPosition"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系手机" prop="contactPhone">
              <el-input v-model.trim="editObj.contactPhone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系座机">
              <el-input
                v-model.trim="editObj.contactLandlinePhone"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog
      title="编辑企业"
      :visible.sync="showEditWindow"
      class="titleChange bodyScroll"
      :width="screenWidth < 1200 ? '94%' : '60%'"
      :close-on-click-modal="false"
    >
      <div class="lineTitle">
        <span>基本信息</span>
      </div>
      <el-form
        :inline="true"
        :model="editObj"
        class="demo-form-inline half"
        size="mini"
        label-width="135px"
        label-position="right"
        ref="editForm"
        :rules="rules"
        v-loading="editLoading"
      >
        <el-row>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业名称" prop="name">
              <el-input
                v-model.trim="editObj.name"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="统一社会信用代码">
              <el-input
                v-model.trim="editObj.code"
                placeholder="请输入"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="登记注册类型">
              <el-select
                v-model="editObj.registerType"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in registerList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
                <el-option label="无" value="无"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="国民经济行业">
              <el-select
                v-model="editObj.industryType"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in industryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
                <el-option label="无" value="无"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册资金（万元）">
              <el-input
                v-model.trim="editObj.registerMoney"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册时间">
              <el-date-picker
                v-model="editObj.registerTime"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="法定代表人">
              <el-input
                v-model.trim="editObj.representativePerson"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="邮政编码">
              <el-input
                v-model.trim="editObj.postCode"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="所在工业园区">
              <el-select v-model="editObj.park" clearable placeholder="请选择">
                <el-option label="不在园区内" value="不在园区内"></el-option>
                <el-option
                  v-for="item in parkList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否规上">
              <el-select
                v-model="editObj.aboveScale"
                clearable
                placeholder="请选择"
              >
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否上市">
              <el-select
                v-model="editObj.listed"
                clearable
                placeholder="请选择"
              >
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否军工">
              <el-select
                v-model="editObj.military"
                clearable
                placeholder="请选择"
              >
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业规模">
              <el-select
                v-model="editObj.companySize"
                clearable
                placeholder="请选择"
              >
                <el-option label="大型" value="大型"></el-option>
                <el-option label="中型" value="中型"></el-option>
                <el-option label="小型" value="小型"></el-option>
                <el-option label="微型" value="微型"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业类别">
              <el-select
                v-model="editObj.companyCategory"
                clearable
                placeholder="请选择"
              >
                <el-option label="50户重点" value="50户重点"></el-option>
                <el-option label="小巨人" value="小巨人"></el-option>
                <el-option label="专精特新" value="专精特新"></el-option>
                <el-option label="隐形冠军" value="隐形冠军"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业性质">
              <el-select
                v-model="editObj.companyNature"
                clearable
                placeholder="请选择"
              >
                <el-option label="国有" value="国有"></el-option>
                <el-option label="民营" value="民营"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="“565”产业">
              <el-cascader
                v-model="editObj.company565"
                :options="Company565List"
                :props="deftProps"
                clearable
                placeholder="请选择"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否10亿元">
              <el-select
                v-model="editObj.oneBillion"
                clearable
                placeholder="请选择"
              >
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="提质倍增">
              <el-select
                v-model="editObj.multiplication"
                clearable
                placeholder="请选择"
              >
                <el-option label="市级" value="市级"></el-option>
                <el-option label="区县级" value="区县级"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否店小二服务">
              <el-select
                v-model="editObj.xiaoerService"
                clearable
                placeholder="请选择"
              >
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="“三大改造”实施">
              <el-select
                v-model="editObj.threeChanges"
                multiple
                placeholder="请选择"
              >
                <el-option label="智能化改造" value="智能化改造"></el-option>
                <el-option label="绿色化改造" value="绿色化改造"></el-option>
                <el-option label="技术改造" value="技术改造"></el-option>
                <el-option label="未实施" value="未实施"></el-option>
                <el-option label="已实施" value="已实施"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册区县" class="selection_item">
              <el-select
                class="city_input_box"
                v-model="luoyangCity"
                :placeholder="city_name"
                disabled
              >
                <el-option :label="city_name" :value="city_name"></el-option>
              </el-select>
              <el-select
                class="city_input_box"
                v-model="editObj.district"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in seatList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册地址">
              <el-input
                v-model.trim="editObj.registerAddress"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="24">
            <el-form-item label="办公地址">
              <el-input
                class="address_input_box"
                v-model.trim="editObj.officeAddress"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="24">
            <el-form-item label="公司简介" prop="companyProfile">
              <el-input
                class="address_input_box"
                type="textarea"
                v-model="editObj.companyProfile"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <hr style="width: 100%; margin: 30px 0" />
        <div class="lineTitle" style="width: 100%">联系信息</div>
        <el-row>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系邮箱">
              <el-input
                v-model.trim="editObj.companyEmail"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="法定代表人电话">
              <el-input
                v-model.trim="editObj.representativePhone"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系人姓名">
              <el-input
                v-model.trim="editObj.contactName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系人职务">
              <el-input
                v-model.trim="editObj.contactPosition"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系手机" prop="contactPhone">
              <el-input
                v-model.trim="editObj.contactPhone"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系座机">
              <el-input
                v-model.trim="editObj.contactLandlinePhone"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item style="width: 100%">
          <div class="btnBox">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="sureDraft('editForm')"
              >存为草稿</el-button
            >
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="sureEdit('editForm')"
              >提交</el-button
            >
            <el-button type="normal" size="mini" @click="showEditWindow = false"
              >取消</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { export2Excel } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  name: "index",
  props: {
    report_cycle: {
      type: String,
      default: "",
    },
    method: {
      type: String,
      default: "",
    },
    region: {
      type: String,
      default: "",
    },
    date_range: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
      showDetailWindow: false,
      showDetailWindow1: false,
      showEditWindow: false,
      editLoading: false,
      vallf: "",
      editObj: {
        id: "",
        refid: "",
        name: "", //企业名称
        code: "", //统一社会信用代码
        registerType: "",
        industryType: "",
        registerMoney: "",
        registerTime: "",
        representativePerson: "",
        postCode: "",
        park: "",
        aboveScale: "",
        listed: "",
        military: "",
        companySize: "",
        companyCategory: "",
        companyNature: "",
        company565: "",
        oneBillion: "",
        multiplication: "",
        xiaoerService: "",
        threeChanges: "",
        district: "",
        registerAddress: "",
        officeAddress: "",
        companyProfile: "",
        companyEmail: "",
        representativePhone: "",
        contactName: "",
        contactPosition: "",
        contactPhone: "",
        contactLandlinePhone: "",
      },
      tableData: [],
      currentPage: 1,
      loading: false,
      formInline: {
        //查询对象
        name: "",
        region: "",
        report_cycle: "",
        date_range: "",
        above_scale: "",
      },
      notPassForm: {
        reason: "",
      },
      regionTree: [],
      passForm: {
        reason: "",
      },
      selectRow: [],
      sureList: [],
      showObj: {},
      pageSize: 10,
      exportLabel: "<<点击此处可导出报表",
      notPassDialogVisible: false,
      passDialogVisible: false,
      notPassLoading: false,
      passLoading: false,
      total: 0, //表格总数
      rules: {
        //表单验证规则
        reason: [
          { required: true, message: "请输入申请原因", trigger: "blur" },
        ],
      },
      detailDialogVisible: false,
      showDialogVisible: false,
      parkList: [],
      industryList: [],
      registerList: [],
      Company565List: [],
      deftProps: {
        expandTrigger: "hover",
        label: "name",
        value: "name",
      },
      luoyangCity: "",
      btndisable: false,
      delBtn: false,
      city_name: "",
    };
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
      seatList1: "getAreaListArr",
    }),
  },
  methods: {
    //提交
    sureEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editLoading = true;
          this.editObj.threeChanges = JSON.stringify(this.editObj.threeChanges);
          if (
            this.editObj.company565 != "" &&
            typeof this.editObj.company565 != "string"
          ) {
            this.editObj.company565 = this.editObj.company565[1];
          }
          this.editObj.refid = this.editObj.refId;
          // this.editObj.id = null;
          this.editObj.updateStatus = 1;
          this.$axios
            .put("/business/updateCompanyEdit", this.editObj)
            .then((res) => {
              if (res.code == 400) {
                this.showEditWindow = false;
              }
              // Message.success("提交成功");
              this.editLoading = false;
              this.showEditWindow = false;
              for (const key in this.editObj) {
                this.editObj[key] = "";
              }
              this.getCompanyList({ pageNum: 1, pageSize: 10 }, this.searchObj);
            })
            .catch(() => {
              this.editLoading = false;
              this.showEditWindow = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //存为草稿
    sureDraft(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editLoading = true;
          this.editObj.threeChanges = JSON.stringify(this.editObj.threeChanges);
          if (
            this.editObj.company565 != "" &&
            typeof this.editObj.company565 != "string"
          ) {
            this.editObj.company565 = this.editObj.company565[1];
          }
          this.editObj.refid = this.editObj.refId;
          // this.editObj.id = null;
          this.editObj.updateStatus = 0;
          console.log(this.editObj);
          this.$axios
            .put("/business/updateCompanyEdit", this.editObj)
            .then((res) => {
              // Message.success("存草稿成功");
              this.getdata(1);
              this.editLoading = false;
              this.showEditWindow = false;
              for (const key in this.editObj) {
                this.editObj[key] = "";
              }
              this.getCompanyList({ pageNum: 1, pageSize: 10 }, this.searchObj);
            })
            .catch(() => {
              this.editLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getSelectList() {
      //获取下拉列表
      // 园区列表
      this.$axios.get("/business/park/selectParkNames").then((res) => {
        this.parkList = res.data;
      });
      // 国民经济行业列表
      this.$axios
        .get("/business/dm/hy/tree", {
          params: {
            parent_code: -1,
            is_select: 0,
          },
        })
        .then((res) => {
          this.industryList = res.data;
        });
      // 登记注册类型
      this.$axios.get("/business/company/selectRegisterType").then((res) => {
        this.registerList = res.data;
      });
      //565列表
      this.$axios.get("/business/company/selectCompany565List").then((res) => {
        this.Company565List = res.data;
        console.log(res.data);
      });
      //获取报表
    },
    handleDetail1(row) {
      console.log(row.id);
      this.$axios
        .get(`/business/selectCompanyEditById?id=${row.id}`)
        .then((res) => {
          console.log(res.data.data);
          this.editObj = res.data.data;
          this.showDetailWindow = true;
        });
    },
    handleDetail2(row) {
      console.log(row.id);
      this.$axios
        .get(`/business/selectCompanyEditById?id=${row.id}`)
        .then((res) => {
          console.log(res.data.data);
          this.editObj = res.data.data;
          // this.showDetailWindow1 = true;
          this.showEditWindow = true;
        });
    },
    handleDetail3(row) {
      console.log(row.id);
      this.$axios
        .delete(`/business/deleteCompanyEditById?id=${row.id}`)
        .then((res) => {
          console.log(res.data.data);
          this.getdata(1);
        });
    },
    getdata(page) {
      // this.loading = true;
      this.tableData = [];
      const param = {
        pageNum: page || 1,
        pageSize: this.pageSize,
        status: 0,
      };
      if (this.formInline.name !== "") {
        param["companyName"] = this.formInline.name;
      }
      if (this.formInline.date_range && this.formInline.date_range !== "") {
        // param["date_range"] = this.$moment(this.formInline.date_range).format(
        //   "YYYY-MM"
        // );
        param["date"] = this.formInline.date_range;
      }

      let methods = "/business/selectCompanyUpdateMsg";
      // if (this.method === 'noRole') {
      //   methods = '/business/insertMonitor/showCompanyByName'
      // }
      console.log(param);
      this.$axios.get(methods, { params: param }).then((res) => {
        this.loading = false;
        console.log(res.data.data.list);
        res.data.data.list.forEach((item) => {
          item.createTime = item.createTime.slice(0, 10);
          if (item.updateStatus == 1) {
            item.updateStatus = "已提交";
            item.btndisable = true;
            this.delBtn = false;
          }
          if (item.updateStatus == 0) {
            item.updateStatus = "草稿";
            this.delBtn = true;
          }
        });
        this.tableData = res.data.data.list;
        console.log(this.tableData);
        this.total = res.data.data.total;
      });
    },
    toDetail(row) {
      this.showDialogVisible = true;
    },
    handleDetail(row) {
      this.showObj = row;
      this.detailDialogVisible = true;
    },
    surePass() {
      this.$refs.passForm.validate((valid) => {
        console.log(valid);
        if (valid) {
          // this.passLoading = true;
          // alert(this.valf)
          const param = {
            opinion: this.passForm.reason,
            id: this.sureList,
            status: "",
          };
          if (this.valf == 0) {
            param.status = 3;
          } else {
            param.status = 2;
          }

          this.$axios
            .put(
              `/business/updateStatusMsg?id=${param.id}&opinion=${param.opinion}&status=${param.status}`
            )
            .then((res) => {
              console.log(res);
              // this.$message.success("催报成功")
              this.getdata(1);
              this.passLoading = false;
              this.passDialogVisible = false;
              this.showDetailWindow1 = false;
            });
        }
      });
    },
    surenoPass() {
      this.$refs.passForm.validate((valid) => {
        console.log(valid);
        if (valid) {
          this.passLoading = true;
          const param = {
            opinion: this.passForm.reason,
            id: this.sureList,
            status: 3,
          };
          console.log(param);
          this.$axios
            .put(
              `/business/updateStatusMsg?id=${param.id}&opinion=${param.opinion}&status=${param.status}`
            )
            .then((res) => {
              console.log(res);
              // this.$message.success("催报成功")
              this.getdata(1);
              this.passLoading = false;
              this.passDialogVisible = false;
              this.showDetailWindow1 = false;
            });
        }
      });
    },
    toPass(rowList, valf) {
      if (rowList.length) {
        this.sureList = rowList;
        this.valf = valf;
        this.passForm = {
          reason: "",
        };
        this.passDialogVisible = true;
      }
    },
    handleSelectionChange(rowTable) {
      this.selectRow = [];
      rowTable.forEach((temp) => {
        this.selectRow.push(temp.id);
      });
    },
    changePage() {
      this.pageNum = this.currentPage;
      this.getdata(this.currentPage);
    },
    handleCurrentChange(val) {
      //跳转页
      this.getdata(val);
    },
    onSubmit() {
      this.getdata(1);
    },
    reset() {
      this.formInline = {
        name: "",
        region: this.region,
        report_cycle: this.report_cycle,
        date_range: this.date_range,
        above_scale: "",
      };
      this.getdata(1);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getdata(1);
    },
    exportData() {
      let column = [
        {
          title: "填报单位",
          key: "company_name",
        },
        {
          title: "报表名",
          key: "name",
        },
        {
          title: "填报期",
          key: "date_range",
        },
        {
          title: "填报开始时间",
          key: "date_range",
        },
        {
          title: "填报结束时间",
          key: "date_range_end",
        },
        {
          title: "上报时间",
          key: "crt_time",
        },
      ];
      export2Excel(column, this.tableData, "未上报");
    },
  },
  created() {
    if (this.report_cycle) {
      this.formInline.report_cycle = this.report_cycle;
    }
    if (this.region) {
      this.formInline.region = this.region;
    }
    if (this.date_range) {
      this.formInline.date_range = this.date_range;
    }
    this.getdata();
    this.getSelectList();
    if (this.seatList1.length) {
      this.city_name = this.seatList1[0];
    }
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
};
</script>

<style scoped>
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
.pagePhone {
  display: none;
}

@media (max-width: 1200px) {
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
  .phone_btn_margin {
    margin-left: 0 !important;
    margin-top: 4px;
  }
}
</style>